export default __webpack_public_path__ + "static/media/logo_multicar_rect_black.e5fbfed0.png";